import { ProgressValues } from '@pc/progress-step-indicator';
import { CoversSteps } from './covers-steps';

export const coversStepProgressMap = {
  [CoversSteps.Comprehensive]: ProgressValues.Ten,
  [CoversSteps.Optional]: ProgressValues.Fifty,
  [CoversSteps.Activity]: ProgressValues.Seventy
};

export const coversFragmentsProgressMap = {
  [CoversSteps.Comprehensive]: 'comprehensive',
  [CoversSteps.Optional]: 'optional',
  [CoversSteps.Activity]: 'activity'
};
